/** @jsx jsx */

import { jsx } from '@emotion/core';
import {
  ServiceIcon as DSServiceIcon,
  ServiceIconSize,
} from '@zapier/design-system-patterns';

import DefaultServiceIcon from './DefaultServiceIcon';

type Props = {
  hasWhiteBackground?: boolean;
  isSymbol: boolean;
  serviceName: string;
  size: ServiceIconSize;
  src?: string;
};

const defaultProps = {
  hasWhiteBackground: true,
  isSymbol: true,
};

/**
 * Renders Service icon
 * When the url isn't provided, it will render the default placeholder
 */
function ServiceIcon(props: Props) {
  const {
    hasWhiteBackground = defaultProps.hasWhiteBackground,
    isSymbol = defaultProps.isSymbol,
    serviceName,
    size,
    src,
  } = props;

  return src ? (
    <DSServiceIcon
      hasWhiteBackground={hasWhiteBackground}
      serviceName={serviceName}
      size={size}
      src={src}
    />
  ) : (
    <DefaultServiceIcon
      hasWhiteBackground={hasWhiteBackground}
      isSymbol={isSymbol}
      size={size}
    />
  );
}

ServiceIcon.defaultProps = defaultProps;

export default ServiceIcon;
